import React from "react";

import { PrimaryButton } from "../../button";

import images from "../../../assets";

const UserProfileHeader = () => {
  return (
    <div className="grid grid-cols-3 justify-center items-center pb-6 fixed bg-[#f3f3fa] z-[5] w-full pt-8">
      <PrimaryButton
        style={{
          width: "90px",
          height: "30px",
          fontSize: "14px",
        }}
        text={"Back"}
        iconalign="left"
        icon={images.leftArrowWhite}
        onClick={() => {
          window.history.back();
        }}
      />

      <h1 className="text-basePrimary text-3xl font-semibold text-center">
        User Profile Dashboard
      </h1>

      <div></div>
    </div>
  );
};

export default UserProfileHeader;
